// Environment Configuration
import {
  DEV_LLM_API_URL,
  QA_LLM_API_URL,
  PROD_LLM_API_URL,
  defaultLlmApiBaseUrlAbsolute,
  resolveAppEnvironment,
} from './environments';
import { resolveRecaptchaSiteKey } from './recaptchaConfig';

const appEnvironment = resolveAppEnvironment();

export const ENV_CONFIG = {
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || appEnvironment,

  // Stripe: use REACT_APP_* only — never commit keys; publishable must be pk_* (never sk_*).
  STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '',

  // Paddle Configuration - Load from environment variables (no hardcoded price defaults)
  PADDLE_CLIENT_KEY: process.env.REACT_APP_PADDLE_CLIENT_KEY,
  PADDLE_ENVIRONMENT: process.env.REACT_APP_PADDLE_ENVIRONMENT,
  PADDLE_PRICE_PRO: process.env.REACT_APP_PADDLE_PRICE_PRO,
  PADDLE_PRICE_PAY_AS_YOU_GO: process.env.REACT_APP_PADDLE_PRICE_PAY_AS_YOU_GO,

  // Google reCAPTCHA v2 site key (REACT_APP_RECAPTCHA_SITE_KEY — gitignored env only)
  RECAPTCHA_SITE_KEY: resolveRecaptchaSiteKey(),

  // API — prefer REACT_APP_API_BASE_URL; else DEV/local absolute, QA or PROD host from environments.js
  API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL !== undefined && process.env.REACT_APP_API_BASE_URL !== ''
      ? process.env.REACT_APP_API_BASE_URL.replace(/\/$/, '')
      : defaultLlmApiBaseUrlAbsolute(),
  API_VERSION: process.env.REACT_APP_API_VERSION || 'v1',

  // Host constants (reference; do not mix QA into PROD builds)
  LLM_HOSTS: {
    development: DEV_LLM_API_URL,
    qa: QA_LLM_API_URL,
    production: PROD_LLM_API_URL,
  },

  // Environment
  NODE_ENV: process.env.NODE_ENV || 'development',
  IS_DEVELOPMENT: appEnvironment === 'development',
  IS_QA: appEnvironment === 'qa',
  IS_PRODUCTION: appEnvironment === 'production',
};

// ***** Code Start BH29072026_1105 - Named exports for Sathis call sites
export const STRIPE_PUBLISHABLE_KEY = ENV_CONFIG.STRIPE_PUBLISHABLE_KEY;
export const PADDLE_CLIENT_KEY = ENV_CONFIG.PADDLE_CLIENT_KEY;
export const PADDLE_ENVIRONMENT = ENV_CONFIG.PADDLE_ENVIRONMENT;
export const PADDLE_PRICE_PRO = ENV_CONFIG.PADDLE_PRICE_PRO;
export const PADDLE_PRICE_PAY_AS_YOU_GO = ENV_CONFIG.PADDLE_PRICE_PAY_AS_YOU_GO;
export const API_BASE_URL = ENV_CONFIG.API_BASE_URL;
export const RECAPTCHA_SITE_KEY = ENV_CONFIG.RECAPTCHA_SITE_KEY;
// ***** Code End BH29072026_1105

export default ENV_CONFIG;
